import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {NgIf} from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-pull-to-refresh-indicator',
  standalone: true,
  imports: [NgIf, ButtonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ptr-spinner app-loading-ring" aria-hidden="true"></div>
    <button *ngIf="refreshing" pButton type="button" class="p-button-text p-button-sm py-1"
            [label]="'common.cancel' | translate" (click)="cancel.emit()"></button>
  `,
  host: {'class': 'flex align-items-center justify-content-center gap-2'},
})
export class PullToRefreshIndicatorComponent {
  @Input() refreshing = false;
  @Output() cancel = new EventEmitter<void>();
}
